import { Check, LayoutGrid, CalendarDays } from "lucide-react";
import { EDITIONS } from "@/lib/edition";

const ICONS = { completa: LayoutGrid, semplice: CalendarDays };

const look = (variant, active) => {
  if (variant === "dark") return "border-white/15 bg-white/5 backdrop-blur-md text-white";
  if (variant === "select") return active ? "border-primary bg-primary/5 ring-2 ring-primary/20" : "border-border hover:border-primary/40";
  return "border-border bg-card";
};

// Le due versioni dell'app: in sola lettura (pagina di accesso) oppure selezionabili (registrazione).
export const EditionCards = ({ value, onChange, variant = "light" }) => (
  <div className="grid grid-cols-2 gap-2.5 sm:gap-3" role={onChange ? "radiogroup" : undefined} data-testid={`edition-cards-${variant}`}>
    {EDITIONS.map((e) => {
      const Icon = ICONS[e.key];
      const active = value === e.key;
      const Tag = onChange ? "button" : "div";
      return (
        <Tag key={e.key} type={onChange ? "button" : undefined} onClick={onChange ? () => onChange(e.key) : undefined}
          role={onChange ? "radio" : undefined} aria-checked={onChange ? active : undefined}
          data-testid={`${onChange ? "register" : "login"}-edition-${e.key}`}
          className={`relative rounded-xl border p-3 sm:p-4 text-left transition-[border-color,background-color,box-shadow] duration-200 ${look(variant, active)}`}>
          {onChange && active && (
            <span className="absolute top-2 right-2 w-5 h-5 rounded-full bg-primary text-primary-foreground flex items-center justify-center"><Check className="w-3 h-3" /></span>
          )}
          <div className={`w-8 h-8 rounded-lg flex items-center justify-center ${e.key === "completa" ? "bg-primary text-white" : "bg-sky-500 text-white"}`}><Icon className="w-4 h-4" /></div>
          <div className="mt-2 font-heading font-bold text-sm sm:text-base leading-tight">{e.title}</div>
          <div className={`text-[10px] uppercase tracking-wider font-semibold ${variant === "dark" ? "text-orange-300" : "text-primary"}`}>{e.tag}</div>
          <ul className={`mt-1.5 space-y-0.5 text-[11px] sm:text-xs leading-snug ${variant === "dark" ? "text-slate-200" : "text-muted-foreground"}`}>
            {e.features.map((f) => <li key={f}>· {f}</li>)}
          </ul>
        </Tag>
      );
    })}
  </div>
);

export default EditionCards;
